import { Alert } from '@mui/material';

import { Icon } from '@/components/Icon/Icon';

import { useTranslate } from '@/hooks/useTranslate';

import { FullPageCenter } from './Layout.styled';

type ResponsiveAppErrorFallbackProps = {
  error: Error | null;
};

function ResponsiveAppErrorFallback({
  error,
}: Readonly<ResponsiveAppErrorFallbackProps>) {
  const { t } = useTranslate();

  return (
    <FullPageCenter>
      <Alert icon={<Icon name="alert" />} color="error" variant="standard">
        {error?.message || t('error.unexpected')}
      </Alert>
    </FullPageCenter>
  );
}

export const renderResponsiveAppErrorFallback = (error: Error | null) => (
  <ResponsiveAppErrorFallback error={error} />
);
